import { useQuery } from "@tanstack/react-query";
import { getContentBlockerTemplateLastEditors } from "../../api/real-cookie-banner.js";
import { useStores } from "../../store/root.js";
import { QueryKeys } from "../../util/query-keys.js";
/**
 * Get last editors since release for given serviceTemplate via RCB ContentBlocker API.
 */ function useGetContentBlockerTemplateLastEditorsSinceRelease(id, enabled = true) {
    const { rcbAuthenticationStore } = useStores();
    return useQuery(QueryKeys.getContentBlockerTemplateLastEditors(id), ({ signal })=>getContentBlockerTemplateLastEditors({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: enabled && String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useGetContentBlockerTemplateLastEditorsSinceRelease };
